module.exports = __webpack_public_path__ + "img/scene-4.b145396.png";